import { render, staticRenderFns } from "./PlayoffMatchCardBR.vue?vue&type=template&id=b0885120&"
import script from "./PlayoffMatchCardBR.vue?vue&type=script&lang=js&"
export * from "./PlayoffMatchCardBR.vue?vue&type=script&lang=js&"
import style0 from "./PlayoffMatchCardBR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports